export default "__VITE_ASSET__CisbWDBV__"